import { plural } from '../plural.js';
/**
 * русские тексты домена. авторские формулировки Кати — дословно, строчными,
 * как в приложении.
 */
const DAYS = (n) => plural(n, 'день', 'дня', 'дней');
const change = (s) => `«${s.name}» ${s.from} → ${s.to}`;
export const ru = {
    intl: 'ru-RU',
    spheres: {
        sostoyanie: 'состояние',
        zdorovie: 'здоровье',
        otnosheniya: 'отношения',
        prostranstvo: 'пространство',
        dengi: 'деньги',
        produkt: 'продукт',
        vliyanie: 'влияние',
        realizatsiya: 'реализация',
    },
    calendar: {
        weekdays: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        monthsDay: [
            'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
            'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
        ],
        monthsTitle: [
            'январь', 'февраль', 'март', 'апрель', 'май', 'июнь',
            'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь',
        ],
        day: (d, month) => `${d} ${month}`.trim(),
        month: (month, y) => `${month} ${y}`,
    },
    chapters: {
        vychislit: 'как себя вычислить',
        panDionisAid: 'пан, дионис и аид',
        nabludatel: 'наблюдатель',
        superpoz: 'восемь сфер',
        pletenie: 'плетение паутины',
        kapli: 'клейкие капли',
        zaryad: 'электрический заряд',
        vibracii: 'вибрации сети',
        estetika: 'эстетика сети',
        shelk: 'экономика шёлка',
        feromony: 'феромоны',
        terpenie: 'терпение',
        evolucia: 'эволюция сети',
    },
    sphereChapters: {
        sostoyanie: 'электрический заряд',
        zdorovie: 'клейкие капли',
        otnosheniya: 'вибрации сети',
        prostranstvo: 'плетение контекста',
        dengi: 'экономика шёлка',
        produkt: 'стиль и подпись',
        vliyanie: 'закрепление внимания',
        realizatsiya: 'терпение',
    },
    balancedChapter: 'суперпозиция',
    personas: {
        dionis: { name: 'Дионис', hint: 'дионис', note: 'дионис возвращает восторг и заряд.' },
        pan: { name: 'Пан', hint: 'пан', note: 'пан включает тело, напор и освобождение.' },
        aid: { name: 'Аид', hint: 'аид', note: 'аид расчищает старое, чтобы выросло новое.' },
        'bog-otec': { name: 'Бог-Отец', hint: 'бог-отец', note: 'бог-отец дает слово, запуск и порядок.' },
        'bog-syn': { name: 'Бог-Сын', hint: 'бог-сын', note: 'бог-сын заботится о людях рядом.' },
        'svyatoy-duh': { name: 'Святой Дух', hint: 'святой дух', note: 'святой дух превращает сделанное в обмен.' },
    },
    prov: {
        sostoyanie: [
            [
                'состояние на дне — а ты тащишь на нём всю систему.',
                'сначала собери себя, потом строй империю. на разряженной батарее далеко не уедешь, и никакая дисциплина это не компенсирует.',
                '10 минут тишины без телефона. прямо сейчас, до следующего дела.',
            ],
            [
                'ты работаешь из минуса и называешь это «надо».',
                'из истощения не создаётся ничего живого — только имитация. состояние это не роскошь, это топливо всех остальных семи сфер.',
                'закрой ноутбук на час и сделай что-то только для себя.',
            ],
        ],
        zdorovie: [
            [
                'здоровье просело, а это твой единственный носитель.',
                'угробишь тело — некому будет получать деньги и влияние. это не сфера «когда будет время», это фундамент, на котором стоит всё.',
                'выпей воды и выйди пройтись на 15 минут. без цели.',
            ],
        ],
        otnosheniya: [
            [
                'отношения проседают — и тихо жрут энергию, которую ты списываешь на «лень».',
                'ты не остров. изоляция маскируется под продуктивность, но на деле это утечка. люди — это не отвлечение от дела, это часть системы.',
                'напиши одному человеку, с которым давно не было связи. сегодня.',
            ],
        ],
        prostranstvo: [
            [
                'пространство в хаосе — значит и в голове хаос, и деньги мимо.',
                'это не мелочь и не эстетика. пространство — твой рычаг: именно оно превращает внутреннюю энергию во внешний результат. забитый канал — забитый поток.',
                'разбери одну поверхность. одну. до конца.',
            ],
        ],
        dengi: [
            [
                'деньги просели — но они никогда не проседают сами.',
                'их роняют другие сферы. гоняться за деньгами напрямую — как лечить температуру, а не болезнь. посмотри, что реально тянет вниз.',
                'выпиши, какая сфера тянет деньги, и займись ей — не деньгами.',
            ],
        ],
        produkt: [
            [
                'продукта нет — и разговаривать не о чем.',
                'влияние и деньги растут из того, что ты делаешь руками, а не из планов о том, что сделаешь. без артефакта рынок тебя просто не видит.',
                'сделай сегодня один кусок продукта, который можно показать.',
            ],
        ],
        vliyanie: [
            [
                'влияние на нуле — значит тебя как будто нет.',
                'гениально в вакууме = никак. если о тебе не знают, твоя ценность существует только у тебя в голове. это не хвастовство, это дистрибуция.',
                'опубликуй одну мысль публично. сегодня, а не «когда готово».',
            ],
        ],
        realizatsiya: [
            [
                'реализация просела: идей на десять жизней, добито — ноль.',
                'реализация — это где мечты либо оживают, либо тихо умирают недосказанными. накопитель незавершёнки давит сильнее, чем кажется.',
                'выбери одно и доведи до «готово» до конца недели.',
            ],
        ],
    },
    observe: {
        balanced: ({ coh }) => ({
            lead: 'ловить нечего — и это тоже диагноз.',
            body: `система на ${coh}%, все сферы над ватерлинией. в таком состоянии опасно одно: замереть и любоваться. суперпозиция живёт, только пока ты в ней двигаешься.`,
            act: 'подними самую сильную сферу ещё на балл — из избытка, не из нужды.',
        }),
        contourIn: 'и заметь: слабее внутренний контур. дело не в стратегии — тебе не из чего действовать.',
        contourOut: 'внутри у тебя огонь, снаружи тишина. энергия есть, а канал в мир забит — чини пространство и продукт, а не мотивацию.',
        lowLead: ({ n }) => `просело ${n} ${plural(n, 'сфера', 'сферы', 'сфер')} — деньги уже теряют опору. `,
    },
    mechanics: {
        'pravilo-dvuh': (c) => ({
            lead: `просело ${c.low.length} ${plural(c.low.length, 'сфера', 'сферы', 'сфер')} — энергия утекает вниз.`,
            body: `${c.low.map(c.nm).join(', ')} ниже ватерлинии. когда проседают две сферы, система начинает схлопываться и тянет за собой остальные.` +
                // про деньги — только если просели сами деньги
                (c.low.includes('dengi') ? ` ${c.nm('dengi')} уже среди них: чини не их, а то, что их роняет.` : ''),
            act: `сделай одно действие в сфере «${c.nm(c.weakest)}» сегодня — не во всех сразу.`,
        }),
        deficit: (c, _v, p) => ({
            lead: `дефицит указывает путь: ${c.nm(c.weakest)}.`,
            body: `${p[1]} дефицит — это добыча, которую нужно вплести в сеть, а не прятать.`,
            act: p[2],
        }),
        proficit: (c) => ({
            lead: `${c.nm(c.top)} блестит на ${c.values[c.top]} — профицит питает.`,
            body: `профицит блестит и притягивает, как капли на паутине. не трать его на удержание — направь в сферу «${c.nm(c.weakest)}», там сейчас дыра.`,
            act: `используй силу сферы «${c.nm(c.top)}», чтобы сделать один шаг в сфере «${c.nm(c.weakest)}».`,
        }),
        kapli: (c, v) => v([
            {
                lead: 'без клея ресурс проходит сквозь сеть.',
                body: 'клей — это количество попыток. не одна великая попытка, а десятки маленьких единиц в матрице. сеть держит только то, что приклеено повторением.',
                act: `поставь сегодня хотя бы одну 1 в сфере «${c.nm(c.weakest)}».`,
            },
            {
                lead: 'устойчивость — это скучно. и это работает.',
                body: 'клейкие капли не бывают эффектными. они просто есть каждый день, и поэтому добыча не уходит.',
                act: 'выбери один навык и отмечай его семь дней подряд. без пропусков.',
            },
        ]),
        zaryad: (c) => ({
            lead: 'сеть тянется к эмоции — а заряда нет.',
            body: `состояние на ${c.values.sostoyanie}, индекс баланса ${c.coh}%. без заряда любая система превращается в обязанность, и ты начинаешь её избегать.`,
            act: 'сделай сегодня одну вещь только ради удовольствия. не полезную — живую.',
        }),
        vibracii: () => ({
            lead: 'сеть молчит: сигналы не доходят.',
            body: 'паук чувствует мир через вибрации нитей. если нити провисли, ты не знаешь, кто рядом и кто резонирует. это не одиночество, это слепота.',
            act: 'напиши трём людям, с которыми хочется резонировать. без повода.',
        }),
        feromony: () => ({
            lead: 'тебя не хотят, потому что о тебе не знают.',
            body: 'феромоны — это сигнал, который совпадает с желанием другого. он сам захотел, ты только подал знак. молчание знаков не подаёт.',
            act: 'опубликуй одну мысль, в которой другой узнает своё желание.',
        }),
        shelk: () => ({
            lead: 'старая паутина висит, новая не соткана.',
            body: 'паук переваривает старую паутину и ткёт из неё новую. незавершёнка — это шёлк, который ты не переработал. он не исчезает, он давит.',
            act: 'доведи до «готово» одну старую вещь. или честно закрой её.',
        }),
        estetika: () => ({
            lead: 'пространство в хаосе — сеть не видна.',
            body: 'маскировка и украшения — это не про красоту, это про то, как сеть работает. захламлённое пространство съедает внимание раньше, чем ты начал.',
            act: 'убери одну поверхность до пустоты. одну.',
        }),
        terpenie: () => ({
            lead: 'заряд есть, результата нет — значит, дёргаешь нити.',
            body: 'терпение — это сила неподвижности. пауза не пустота, а активное действие: паук ждёт в центре сети, а не бегает по краям.',
            act: 'выбери одно дело и не переключайся с него два часа.',
        }),
        kontekst: () => ({
            lead: 'внешнее из чужих нитей рвётся.',
            body: 'ценности — это нити, из которых плетётся контекст. если деньги, продукт и влияние сплетены из чужих желаний, они рвутся при первом ветре.',
            act: 'запиши три свои ценности и вычеркни одно дело, которое им не служит.',
        }),
        zhivaya: (c) => ({
            lead: 'ловить нечего — и это тоже диагноз.',
            body: `система на ${c.coh}%, все сферы над ватерлинией. если сеть всегда натянута одинаково, она мертва. живая паутина меняется.`,
            act: 'подними самую сильную сферу ещё на балл — из избытка, не из нужды.',
        }),
    },
    verdict: (() => {
        const score = (d) => `${d.done} из ${d.skills}, ${d.pct}%`;
        const idleList = (idle) => idle.slice(0, 5).join(', ') + (idle.length > 5 ? ` и еще ${idle.length - 5}` : '');
        // правило Кати: каждый 0 — не пропуск, а потеря
        const ZERO_NOTE = [
            'каждый 0 в матрице — не пропуск, а потеря: все, чему не даешь внимания, времени и энергии, распадается.',
            '0 — это не пауза. навык без внимания тает, и завтра начинать придется с меньшего.',
        ];
        return {
            empty: {
                lead: 'матрица пустая — наблюдать не за чем.',
                body: 'колесо без матрицы — это настроение. точка б появляется там, где каждый день стоят единицы.',
                act: 'добавь в матрицу три навыка: один во внутренний контур и один во внешний.',
            },
            zero: (d, v) => ({
                lead: v([`сегодня 0 из ${d.skills}.`, `сегодня ни одной единицы из ${d.skills}.`]),
                body: `${v(ZERO_NOTE)} пока в строках нули, точка б не приближается: ты стоишь в точке а и называешь это планом.`,
                act: 'поставь одну 1 до сна. любую.',
            }),
            start: (d, v) => {
                const idle = idleList(d.idle);
                return {
                    lead: v([`${score(d)}. для начала — хорошо.`, `${score(d)}: шаг сделан.`]),
                    body: 'такие шаги рано или поздно приводят к цели. но если не ускоришься, на жизнь мечты останется совсем мало времени.' +
                        (idle ? ` ждут: ${idle}.` : ''),
                    act: 'добавь сегодня еще одну единицу, хотя бы самую маленькую.',
                };
            },
            harsh: (d, v) => {
                const idle = idleList(d.idle);
                return {
                    lead: v([`${score(d)}. серьезно? это и есть твой максимум?`, `${score(d)}. так двигаются те, у кого ничего не выйдет.`]),
                    body: v([
                        'ты делаешь ровно столько, чтобы не было стыдно, и ровно столько, чтобы ничего не изменилось. через год будет то же самое, только старше.',
                        'большинство останавливается здесь и потом рассказывает, что не повезло. проверь, хочешь ли в эту очередь.',
                    ]) + (idle ? ` стоят без единиц: ${idle}.` : ''),
                    act: `выбери из них два и сделай до вечера. не завтра.`,
                };
            },
            pace: (d, v) => {
                const say = (m, f, n) => (d.gender === 'm' ? m : d.gender === 'f' ? f : n);
                return {
                    lead: v([`${score(d)}. набираешь темп.`, `${score(d)}: уже похоже на движение.`]),
                    body: v([
                        say('ты похож на человека, который хотя бы пытается. это уже больше, чем делают несколько миллиардов людей.', 'ты похожа на человека, который хотя бы пытается. это уже больше, чем делают несколько миллиардов людей.', 'это уже похоже на попытку — а это больше, чем делают несколько миллиардов людей.'),
                        'пытаться — уже не ноль. большинство даже не открывает матрицу.',
                    ]),
                    act: d.idle.length ? `верни в работу «${d.idle[0]}» — одна 1 сегодня.` : 'закрой сегодня все навыки хотя бы по разу.',
                };
            },
            big: (d, v) => ({
                lead: v([`${score(d)}. ты явно затеваешь что-то большое.`, `${score(d)}: заявка на выдающееся.`]),
                body: v([
                    'но пытающихся много. возможно, отдых и восстановление сейчас важнее успеха — чилл тоже ок, для большинства. хочешь остаться среди большинства или перейти на следующий уровень?',
                    'таких, как ты сейчас, много: делают половину и ждут результата целиком. решай, где ты хочешь быть через месяц — в середине или наверху.',
                ]),
                act: 'добери сегодня еще два навыка — и ты в другой лиге.',
            }),
            worthy: (d, v, narrow) => ({
                lead: v([`${score(d)}. достойно.`, `${score(d)}: такими темпами уходят далеко.`]),
                body: 'проверь колесо: развиваешь навыки из разных сфер или вкладываешь все силы в один сектор?' +
                    (narrow ? ` сегодня единицы стоят всего в ${d.spheresTouched} ${plural(d.spheresTouched, 'сфере', 'сферах', 'сферах')} — паутина тянется в одну сторону.` : ''),
                act: 'завтра начни день со сферы, которая сегодня осталась без единиц.',
            }),
            spider: (d, v) => ({
                lead: v([`${score(d)}. уровень паука.`, `${score(d)}: так работают архонты.`]),
                body: v([
                    'архонты на земле встречаются нечасто, и тебе не стоит частить с турбо-эффективностью.',
                    'сеть держится не только на напряжении, но и на паузе. перегруз — тоже способ сорваться.',
                ]),
                act: 'сегодня выполни практику в озере, а завтра удели время ничегонеделанию.',
            }),
        };
    })(),
    mismatch: {
        doneButLow: ({ sphere, value }) => `в сфере «${sphere}» навыки делаются, а оценка все равно ${value}. возможно, эти навыки не ведут к цели — пересмотри их в следующем месяце.`,
        emptyLow: ({ sphere }) => `сфера «${sphere}» просела, а навыков в ней нет ни одного. откуда там взяться росту?`,
    },
    goals: {
        none: 'второй месяц: поставь цели в матрице — сколько раз в месяц ты хочешь делать каждый навык. и проверь, ведет ли каждый навык к цели.',
        lost: ({ items, more }) => `цель уже не успеть: ${items.map((x) => `«${x.name}» (${x.done} из ${x.goal})`).join(', ')}${more > 0 ? ` и еще ${more}` : ''}.`,
        behindMany: ({ n }) => `отстаешь от цели по ${n} навыкам — скорректируй цели в матрице, чтобы они тянули вперед, а не давили.`,
        behind: ({ names }) => `отстаешь от цели: ${names.join(', ')}.`,
        ok: 'цели месяца идут в темпе. держи.',
    },
    lake: {
        zero: ({ sphere }) => `если сегодня сфера «${sphere}» осталась без внимания, хотя бы выполни практику в озере.`,
        practice: ({ sphere }) => `сегодня выполни практику в озере: «${sphere}».`,
    },
    haiku: {
        balanced: ({ top }) => [
            ['все нити натянуты', 'капли держат свет', 'шевельни одну — сеть жива'],
            ['сеть звучит ровно', `«${top}» блестит сильнее всех`, 'не замри в тишине'],
            ['паук в центре сети', 'ветер проходит, не рвет', 'плети дальше'],
        ],
        money: ({ money }) => [
            [`нить «${money}» провисла`, 'ее роняют другие нити', 'найди, какая тянет вниз'],
            [`«${money}» ниже воды`, 'деньги идут по натянутой сети', 'подтяни соседнюю нить'],
        ],
        one: ({ weak }) => [
            [`нить «${weak}» провисла`, 'ветер проходит насквозь', 'подтяни одну — и сеть запоет'],
            [`«${weak}» ниже воды`, 'дефицит — это добыча', 'вплети его в сеть'],
            [`в сети дыра: «${weak}»`, 'капля падает мимо', 'сделай один шаг туда'],
        ],
        many: ({ weak, second, money, count }) => [
            [`рвутся «${weak}» и «${second}»`, 'энергия течет вниз', money !== null ? `и «${money}» уже в воде` : `начни с «${weak}»`],
            [`${count} ${plural(count, 'нить', 'нити', 'нитей')} ниже воды`, 'паук не бегает по краям', `чини «${weak}» первой`],
            ['сеть провисает', `«${weak}» тянет за собой «${second}»`, 'одна нить сегодня'],
        ],
    },
    report: {
        filled: ({ filled, days, pct, ones, streak }) => `заполнено ${filled} ${DAYS(filled)} из ${days} (${pct}%), единиц за месяц: ${ones}. самая длинная серия подряд: ${streak} ${DAYS(streak)}.`,
        balance: ({ from, to }) => {
            const d = to - from;
            return (`индекс баланса: ${from}% → ${to}%` +
                (d > 0 ? ` (+${d}). система собирается.` : d < 0 ? ` (${d}). система теряет опору — смотри, какие сферы тянут вниз.` : '. без движения.'));
        },
        noBalance: 'удовлетворенность сферами не видна: фиксируй день в колесе хотя бы раз в неделю, и в следующем отчете появятся закономерности.',
        keep: ({ list }) => `навыки работают: ${list.map(change).join(', ')}. оставь их.`,
        replace: ({ list }) => `навыки делались, а сфера не растет: ${list.map(change).join(', ')}. похоже, эти навыки не ведут к цели — замени их в следующем месяце.`,
        neglected: ({ list }) => `без внимания сфера проседает: ${list.map(change).join(', ')}. добавь туда хотя бы один навык.`,
        grows: ({ list }) => `растет и без навыков: ${list.map(change).join(', ')}. проверь, что именно ее питает, и внеси это в матрицу.`,
        noSkills: ({ names }) => `сферы без навыков: ${names.join(', ')}.`,
        top: ({ items }) => `чаще всего: ${items.map((t) => `${t.name} (${t.ones})`).join(', ')}.`,
        idle: ({ names, more }) => `почти не делались: ${names.join(', ') + (more > 0 ? ` и еще ${more}` : '')}. замени или убери — пустые строки только размывают матрицу.`,
        goals: ({ reached, set }) => `цели: достигнуто ${reached} из ${set}.`,
        practices: ({ lake, weak }) => `второй месяц позади — время новых практик. ${lake.length ? `в озере есть практики: ${lake.join(', ')}.` : 'в озере появляются новые практики каждую неделю.'}` +
            (weak !== null ? ` начни со сферы «${weak}»: она сейчас ниже всех.` : ''),
    },
};
//# sourceMappingURL=ru.js.map